import { useEffect } from "react";
import useLocalStorage from "./useLocalStorage";
import { useWindow } from "./useWindow";
import { useApi } from "./useAPI";
import isDev from "@utils/isDev";
import { mockTranslationFile } from "../../client/mocks/mockTranslationFile";
const useLoadTranslations = () => {
    const myWindow = useWindow();
    const { getItem, setItem } = useLocalStorage();
    const { get } = useApi();
    const getMockTranslations = () => {
        return new Promise((resolve) => {
            setTimeout(() => {
                resolve(mockTranslationFile);
            }, 1000);
        });
    };
    const getLocalHash = () => {
        const translations = getItem("translations");
        return translations === null || translations === void 0 ? void 0 : translations.hash;
    };
    const fetchTranslations = async () => {
        const localHash = getLocalHash();
        const query = localHash ? new URLSearchParams({ hash: localHash }).toString() : "";
        const translationsData = await get(`api/localization/getall?${query}`).json();
        return {
            hash: translationsData === null || translationsData === void 0 ? void 0 : translationsData.hash,
            ...translationsData === null || translationsData === void 0 ? void 0 : translationsData.data
        };
    };
    const initTranslations = async () => {
        let translationsFile;
        if (isDev()) {
            translationsFile = await getMockTranslations();
        }
        else {
            translationsFile = await fetchTranslations();
        }
        setItem("translations", translationsFile);
        myWindow.dispatchEvent(new Event("storage"));
    };
    useEffect(() => {
        myWindow && initTranslations();
    }, [myWindow]);
    return {
        initTranslations
    };
};
export default useLoadTranslations;
